import Finances from '../src/Finances/index.tsx';
export default Finances;
